import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { SearchLinkModule } from 'src/app/shared/search-link/search-link.module';
import { LocationListModule } from 'src/app/shared/location-list/location-list.module';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { ReplaceStrPipe } from 'src/app/shared/pipes/replace-str.pipe';
import { ParseCoordinatesPipe } from 'src/app/shared/pipes/parse-coordinates.pipe';

import { ScrollToIdService } from 'src/app/core/services/scroll-to-id.service';
import { CountryInfoTextService } from '../../../services/country-info-text.service';
import { MetaTagsConfigService } from 'src/app/core/services/meta-tags-config.service';

import { PageInfoComponent } from '../../../pages/page-info';
import { SimpleMapComponent } from 'src/app/shared/maps/simple-map/simple-map.component';
import { TextEllipsisComponent } from 'src/app/shared/components/text-ellipsis/text-ellipsis.component';
import { SimpleBreadcrumbComponent } from '../../../components/simple-breadcrumb/simple-breadcrumb.component';
import { GalleryMobileComponent } from '../../../../countries/components/mobile/gallery-mobile/gallery-mobile.component';
import { StartPlaningMobileComponent } from 'src/app/shared/components/start-planing-mobile/start-planing-mobile.component';
import { RegionListMobileComponent } from '../../../../countries/components/mobile/region-list-mobile/region-list-mobile.component';
import { ItineraryListMobileComponent } from '../../../../countries/components/mobile/itinerary-list-mobile/itinerary-list-mobile.component';
import { AttractionListMobileComponent } from '../../../../countries/components/mobile/attraction-list-mobile/attraction-list-mobile.component';

@Component({
  selector: 'app-country-info-page-mobile',
  templateUrl: './country-info-page-mobile.component.html',
  styleUrls: ['./country-info-page-mobile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    LocationListModule,
    MatIconModule,
    MatMenuModule,
    NgxSkeletonLoaderModule,
    ParseCoordinatesPipe,
    SearchLinkModule,
    SimpleBreadcrumbComponent,
    TitleCasePipe,
    SimpleMapComponent,
    ReplaceStrPipe,
    AsyncPipe,
    StartPlaningMobileComponent,
    RegionListMobileComponent,
    AttractionListMobileComponent,
    ItineraryListMobileComponent,
    TextEllipsisComponent,
    GalleryMobileComponent,
  ],
  providers: [CountryInfoTextService],
})
export class CountryInfoPageMobileComponent
  extends PageInfoComponent
  implements OnInit, OnDestroy
{
  protected readonly eSvgIcons = ESvgIcons;
  public menuOpened: boolean[] = [];

  constructor(
    protected cdr: ChangeDetectorRef,
    protected scrollToIdService: ScrollToIdService,
    protected countryInfoTextService: CountryInfoTextService,
    private readonly metaTagsConfigService: MetaTagsConfigService,
    protected route: ActivatedRoute,
  ) {
    super(cdr, scrollToIdService);
  }

  ngOnInit() {
    if (this.countryDetails.name) {
      this.metaTagsConfigService.setCountrySeoTags(this.countryDetails.name);
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
